import { AppRoutes, ROUTE_LABELS } from '@/constants';

import { FaceIdIcon, FolderCodeIcon, TabletIcon, UsersIcon } from '@/assets/icons';

import { INavItem } from './FloatingNavBar.interfaces';

export const NAV_ITEMS: INavItem[] = [
  {
    id: AppRoutes.FACE_ID_PROFILES,
    label: ROUTE_LABELS[AppRoutes.FACE_ID_PROFILES],
    icon: FaceIdIcon,
  },
  {
    id: AppRoutes.IPAD_CONFIGURATIONS,
    label: ROUTE_LABELS[AppRoutes.IPAD_CONFIGURATIONS],
    icon: TabletIcon,
  },
  {
    id: AppRoutes.CHECK_IN_LOGS,
    label: ROUTE_LABELS[AppRoutes.CHECK_IN_LOGS],
    icon: FolderCodeIcon,
  },
  {
    id: AppRoutes.ROLE_ASSIGNMENTS,
    label: ROUTE_LABELS[AppRoutes.ROLE_ASSIGNMENTS],
    icon: UsersIcon,
  },
];
